/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { CheckboxGroup as TelusCheckboxGroup } from '@telus-uds/components-web';
import { useTranslation } from 'react-i18next';

import useStore from '../../../store/store';
import { getLabel } from '../util';

export default function CheckboxGroup({ fieldData }) {
  const { t } = useTranslation(['form']);
  const { selectedFormValues, setSelectedFormValues } = useStore(
    (state) => state
  );

  const { id, name, options, hint, toolTip, required } = fieldData;
  const { value: fieldValue, error } = selectedFormValues[name];

  const optionsItems = options.map((option) => ({
    label: option.fields.label,
    id: option.fields.value,
  }));

  const handleOnChange = (selectedValue) => {
    setSelectedFormValues((previousValue) => ({
      ...previousValue,
      [name]: {
        ...previousValue[name],
        value: selectedValue,
        touched: true,
        ...(required && !selectedValue
          ? { error: t('labelFieldRequired') }
          : { error: '' }),
      },
    }));
  };

  const fieldProps = {
    legend: getLabel(fieldData),
    items: optionsItems,
    ...(hint && { hint, hintPosition: 'below' }),
    ...(error && { validation: 'error', feedback: error }),
    ...(toolTip && { tooltip: toolTip }),
    checkedIds: fieldValue || [],
    onChange: handleOnChange,
  };

  useEffect(() => {
    return () => {
      setSelectedFormValues((previousValue) => ({
        ...previousValue,
        [name]: {
          ...previousValue[name],
          value: '',
        },
      }));
    };
  }, []);

  return (
    <div id={id}>
      <TelusCheckboxGroup {...fieldProps} />
    </div>
  );
}

CheckboxGroup.propTypes = {
  fieldData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.string,
    type: PropTypes.string,
    hint: PropTypes.string,
    toolTip: PropTypes.string,
    error: PropTypes.string,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
        }),
      })
    ),
  }).isRequired,
};
